var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PersonSpeakingIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 53,
    glyphHeight: 72,
    glyphOffsetY: 3
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9565 71.7095V41.4709H39.9565V71.7095C43.0227 70.6854 45.9276 69.309 48.6232 67.6284V41.4709H52.9565V32.8042H39.9565C39.9565 25.6542 34.1065 19.8042 26.9565 19.8042C19.8065 19.8042 13.9565 25.6542 13.9565 32.8042H0.956543V41.4709H5.28988V67.6284C7.98547 69.309 10.8904 70.6854 13.9565 71.7095ZM18.2899 8.97086C18.2899 4.2042 22.1899 0.304199 26.9565 0.304199C31.7232 0.304199 35.6232 4.2042 35.6232 8.97086C35.6232 13.7375 31.7232 17.6375 26.9565 17.6375C22.1899 17.6375 18.2899 13.7375 18.2899 8.97086ZM22.6232 8.97086C22.6232 11.3542 24.5732 13.3042 26.9565 13.3042C29.3399 13.3042 31.2899 11.3542 31.2899 8.97086C31.2899 6.58753 29.3399 4.63753 26.9565 4.63753C24.5732 4.63753 22.6232 6.58753 22.6232 8.97086ZM26.9565 28.4709C24.5732 28.4709 22.6232 30.4209 22.6232 32.8042H31.2899C31.2899 30.4209 29.3399 28.4709 26.9565 28.4709Z"
  }));
};
export var PersonSpeakingIconGlyph = function (props) {
  return React.createElement(PersonSpeakingIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};